import { render, staticRenderFns } from "./ConfirmSmsTestInput.vue?vue&type=template&id=1504741e&scoped=true"
import script from "./ConfirmSmsTestInput.vue?vue&type=script&lang=js"
export * from "./ConfirmSmsTestInput.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSmsTestInput.vue?vue&type=style&index=0&id=1504741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504741e",
  null
  
)

export default component.exports